import jsonp from 'jsonp';
export default {
    request: new XMLHttpRequest(),

    init(el) {
        this.alert = document.querySelector('.js-alert');

        this.traffic = this.getTrafficSource(this.get_top_domain());

        [...el.querySelectorAll('input')].forEach(field => {
            field.addEventListener('invalid', e => this.setMessage(e));
            field.addEventListener('input', e => this.setMessage(e));
        });

        el.addEventListener('submit', e => this.submitForm(e));

        this.request.addEventListener('error', err =>
            console.log('error', err)
        );
        this.request.addEventListener('load', res => console.log(res));

        el.querySelector('select[name=place]').addEventListener('change', () => this.updateStand(el));

        this.alert
            .querySelector('.js-alert-close')
            .addEventListener('click', () => this.closeAlert());
    },

    openAlert() {
        this.alert.classList.remove('hidden');
    },

    closeAlert() {
        this.alert.classList.add('hidden');
    },

    setMessage(e) {
        const field = e.target;
        const invalidText = field.getAttribute('data-invalid');

        field.setCustomValidity('');

        if (!field.validity.valid) {
            field.setCustomValidity(invalidText);
        }
    },

    mailchimpForm(values) {
        jsonp(
                'https://minuscode.us18.list-manage.com/subscribe/post-json?u=6e69377f88397eaa5fcfd8fdb&id=c8f5f9a8cb' + '&' + values,
                    { param: 'c' },
                    (err, data) => {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ event: 'FormSubmissionSuccess' });
                        console.log(data);
                    }
                );
    },

    getParam(s, q) {
        try {
            if (s.indexOf("?") == 0) return s.substr(1).match(RegExp("(^|\x26)" + q + "\x3d([^\x26]*)"))[2];
            else return s.match(RegExp("(^|\x26)" + q + "\x3d([^\x26]*)"))[2]
        } catch (e) { return "" }
    },

    get_top_domain() {
        let i, h, weird_cookie = "weird_get_top_level_domain\x3dcookie", hostname = document.location.hostname.split("."); 
        for (i = hostname.length - 1; i >= 0; i--) { 
            h = hostname.slice(i).join(".");
            document.cookie = weird_cookie + ";domain\x3d." + h + ";"; 
            if (document.cookie.indexOf(weird_cookie) > -1) { 
                document.cookie = weird_cookie.split("\x3d")[0] + "\x3d;domain\x3d." + h + ";expires\x3dThu, 01 Jan 1970 00:00:01 GMT;"; 
                return h; 
            } 
        }
    },

    getTrafficSource(hostname) {
        const trafficSources = this.calculateTrafficSource(hostname);
        const value = trafficSources;
        return value;
    },

    getChannel(traffic) {
        let channel = "";
        let socialRegex = /^(social|social-network|social-media|sm|social network|social media)$/;
        let socialMediaRegex = /google\+|facebook|twitter|qzone|sina weibo|instagram|habbo|vk|tumblr|linkedin|renren|bebo|tagged|orkut|netlog|friendster|hi5|flixster|mylife|classmates.com|sonico.com|plaxo|douban|odnoklassniki|viadeo|flickr|weeworld|last.fm|myspace|myheritage|xanga|deviantart|mixi|cyworld|gaia online|skyrock|foursquare|fotolog|we heart it|stumbleupon|blackplanet|friends reunited|academia.edu|livejournal|studivz|geni.com|goodreads|tuenti|busuu|xing|taringa!|nasza-klasa.pl|wayn|soundcloud|buzznet|care2|caringbridge|stickam|delicious|my opera|about.me|open diary|livemocha|trombi.com|weread|ibibo|untappd|tylted|ravelry|43 things|mocospace|jiepang|couchsurfing|fetlife|draugiem.lv|rooster teeth|etoro|itsmy|kiwibox|grindr|grono.net|dxy.cn|getglue|vampirefreaks.com|fotki|english, baby!|travbuddy.com|nexopia|librarything|cafemom|uplike|streetlife|minds|zoo.gr|focus.com|influenster|diaspora*|asmallworld|irc-galleria|ryze|reverbnation.com|italki.com|gather.com|millatfacebook|girlsaskguys|socialvibe|biip.no|skoob|doximity|identi.ca|indaba music|hospitality club|partyflock|travellerspoint|gamerdna|smartican|filmaffinity|spot.im|laibhaari|mubi|hr.com|elftown|stage 32|cozycot|athlinks|goodwizz|patientslikeme|gays.com|elixio|hotlist|writeaprisoner.com|fuelmyblog|dol2day|hub culture|late night shots|advogato|poolwo|the sphere|anobii|asianavenue|audimated.com|bolt.com|cloob|clusterflunk|crunchyroll|cucumbertown|dailybooth|dailystrength|disaboom|dontstayin|dreamwidth|ello|eons.com|epernicus|experience project|exploroo|filmow|fledgewing|friendica|fyuse|gapyear.com|gentlemint|gogoyoko|govloop|jaiku|kaixin001|lifeknot|linkexpats|listography|makeoutclub|meetin|meettheboss|meetup (website)|mog|mouthshut.com|ning|outeverywhere|pingsta|pinterest|playfire|playlist.com|plurk|qapacity|quechup|quora|raptr|sciencestage|sgrouples|sharethemusic|shelfari|spaces|spring.me|students circle network|talkbiznow|taltopia|teachstreet|termwiki|tribe.net|tsu|virb|vox|wattpad|wellwer|wepolls.com|wer-kennt-wen|wooxie|xt3|yammer|yelp, inc.|yookos/;
        let paidSearchRegex = /^(cpc|ppc|paidsearch)$/;
        let otherAdvertisingRegex = /^(cpv|cpa|cpp|content-text)$/;
        let displayRegex = /^(display|cpm|banner)$/;
        let smsRegex = /^(sms|SMS)$/;
        if (paidSearchRegex.test(traffic.medium)) channel = "Paid Search";
        else if (traffic.medium == "affiliate") channel = "Affiliates";
        else if (traffic.source == "direct" && traffic.medium == "(not set)" || traffic.medium == "web") channel = "Direct";
        else if (traffic.medium == "organic") channel = "Organic Search";
        else if (traffic.medium == "influencer" || traffic.medium ==
            "influencers") channel = "Influencers";
        else if (traffic.medium == "paid social" || traffic.medium == "paidsocial" || traffic.medium == "paid%20social") channel = "Paid Social";
        else if (socialRegex.test(traffic.medium) && "51.com:academia:activerain:addthis:allnurses:allrecipes:allvoices:ameba:android central:anobii:answerbag:aol answers:ask ubuntu:askville:baby gaga:babyblog:before it's news:bigtent:bitly:blogcu:bloggang:blogger:blogher:bloglines:blogs.com:blogsome:blogster:blurtit:buzzfeed:buzznet:cafemom:care2:caringbridge:catster:cg hub:chicagonow:circle of moms:cocolog:couchsurfing:crunchyroll:cyworld:dailybooth:dailymotion:dailystrength:delicious:deviantart:digg:diigo:disqus:dogster:douban:draugiem.lv:drugs-forum:dzone:experience project:facebook:facebook apps:families.com:fanpop:fark:fc2:feministing:ffffound!:filmaffinity:flavors.me:flickr:foodservice.com:formspring:foursquare:friendfeed:fubar:gaia online:gather:glassdoor:goldenline:goo blog:goo.gl:goodreads:google groups:google+:govloop:gutefrage.net:hacker news:hatena bookmark:hatena diary:hootsuite:identi.ca:imvu:insanejournal:instapaper:internations:interpals:jappy:jigsaw:justin.tv:kaboodle:klicknation:last.fm:librarything:linkedin:listal:livejournal:meetup:meneame:metroflog:mixi:mubi:my modern met:my opera:myfamily:myspace:naver:netlog:netvibes:nico nico douga:ning:nk.pl:nowpublic:odnoklassniki:okwave:one world:onstartups:open diary:orkut:oshiete! goo:paper.li:photobucket:pinboard:pinterest:pixiv:plaxo:plurk:pocket:polyvore:posterous:quora:ravelry:reddit:renren:researchgate:reverbnation:sciencestage:scribd:sina weibo:skyrock:slashdot:slideshare:sonico:spoke:squidoo:stack exchange:stack overflow:stumbleupon:super user:tagged:taringa!:techmeme:tinyurl:topix:travbuddy:tripadvisor:tudou:tuenti:tumblr:tweetdeck:twitter:typepad:ustream:vampirefreaks.com:viadeo:vimeo:virb:vkontakte:wattpad:weebly:wer-kennt-wen:wer-weiss-was:wikia:wikianswers:wikihow:wikitravel:wiserearth:woot:wordpress:wretch:xanga:xing:yahoo! answers:yahoo! bookmarks:yammer:yelp:youku:youtube:yuku:zinch".indexOf(":" +
            traffic.source + ":") > 0 || socialMediaRegex.test(traffic.source)) channel = "Social";
        else if (traffic.medium == "email") channel = "Email";
        else if (traffic.medium == "paid email" || traffic.medium == "paidemail" || traffic.medium == "paid%20email") channel = "Paid Email";
        else if (smsRegex.test(traffic.medium)) channel = "SMS";
        else if (traffic.medium == "referral") channel = "Referral";
        else if (displayRegex.test(traffic.medium)) channel = "Display";
        else if (otherAdvertisingRegex.test(traffic.medium)) channel = "Other Advertising";
        else if (paidSearchRegex.test(traffic.medium)) channel =
            "Paid Search";
        else channel = "(Other)";
        return channel;
    },

    calculateTrafficSource(hostname) {
        let source = "",
            medium = "",
            campaign = "",
            term = "",
            content = "",
            gclid = "";
        let search_engines = [
            ["bing", "q"],
            ["google", "q"],
            ["yahoo", "q"],
            ["ask", "q"],
            ["msn", "q"]
        ];
        let ref = document.referrer;
        ref = ref.substr(ref.indexOf("//") + 2);
        let ref_domain = ref;
        let ref_path = "/";
        let ref_search = "";
        let url_search =
            document.location.search;
        gclid = this.getParam(url_search, "gclid");
        if (gclid && ref_domain.indexOf("google") > -1) {
            source = this.getParam(url_search, "utm_source") || "google";
            medium = "cpc";
            campaign = this.getParam(url_search, "utm_campaign")
        } else if (gclid) {
            source = this.getParam(url_search, "utm_source") || ref.substr(0, ref.indexOf("/"));
            medium = "display";
            campaign = this.getParam(url_search, "utm_campaign")
        } else if (url_search.indexOf("utm_source") > -1) {
            source = this.getParam(url_search, "utm_source");
            medium = this.getParam(url_search, "utm_medium");
            campaign = this.getParam(url_search,
                "utm_campaign");
            term = this.getParam(url_search, "utm_term");
            content = this.getParam(url_search, "utm_content")
        } else if (ref) {
            if (ref.indexOf("/") > -1) {
                ref_domain = ref.substr(0, ref.indexOf("/"));
                ref_path = ref.substr(ref.indexOf("/")); if (ref_path.indexOf("?") > -1) {
                    ref_search = ref_path.substr(ref_path.indexOf("?") + 1);
                    ref_path = ref_path.substr(0, ref_path.indexOf("?"))
                }
            }
            medium = "referral";
            source = ref_domain;
            for (let i = 0; i < search_engines.length; i++)
                if (ref_domain.indexOf(search_engines[i][0]) > -1) {
                    medium = "organic";
                    source = search_engines[i][0];
                    term = this.getParam(ref_search, search_engines[i][1]) || "(not provided)";
                    break
                }
            if (source && source.indexOf(hostname) > -1) {
                source = "direct";
                medium = "web"
            }
        } else {
            source = "direct";
            medium = "web"
        }
        if (!gclid) gclid = "";
        const value = { "source": source, "medium": medium, "campaign": campaign };
        value.channel = this.getChannel(value);
        return value;
    },

    originName() {
        return window.location.pathname == '/' ? 'Landing_A_Campanha_KiaAprovado_202007' : 'Landing_B_Campanha_KiaAprovado_202007';
    },

    subSource() {
        return window.location.pathname == '/' ? '11' : '20';
    },

    submitForm(e) {
        e.preventDefault();
        const button = e.target.querySelector('[type=submit]');
        const values = [...e.target.elements]
            .map(input => input.name.toUpperCase() + '=' + encodeURIComponent(input.value))
            .join('&');

        const _this = this;

        button.classList.add('loading');
        this.closeAlert();

        const json = JSON.stringify([{
            "Marca": "Kia_Portugal",
            "MotivoContacto": "campanha_test-drive",
            "origen": "Web de la marca",
            "Suborigen": _this.subSource(),
            "Nombre": e.target.querySelector("input[name=name]").value.split(' ')[0],
            "Apellidos": e.target.querySelector("input[name=name]").value.split(' ')[1],
            "AceptoTYC": true,
            "gdprDealer": e.target.querySelector("input[name=datatreatment]").checked ? true : false,
            "gdprmarca": e.target.querySelector("input[name=datatreatment]").checked ? true : false,
            "tratamientoDatos": true,
            "legalTratamientoDatos": 'Ao completar este formulário autorizo a utilização dos meus dados, e a comunicação dos mesmos aos concessionários autorizados KIA, para tratamento no âmbito da finalidade deste formulário',
            "legalComunicaciones": e.target.querySelector("input[name=datatreatment]").checked ? 'Aceito o tratamento dos meus dados pela Kia Portugal para fins de campanhas de Marketing, comunicação de novidades, convites para eventos, inquéritos e informação institucional' : '',
            "legalTratamientoDatos": "Ao completar este formulário autorizo a utilização dos meus dados, e a comunicação dos mesmos aos concessionários autorizados KIA, para tratamento no âmbito da finalidade deste formulário.",
            "legalComunicaciones": "Aceito o tratamento dos meus dados pela Kia Portugal para fins de campanhas de Marketing, comunicação de novidades, convites para eventos, inquéritos e informação institucional.",
            "email": e.target.querySelector("input[name=email]").value,
            "telefono": e.target.querySelector("input[name=phone]").value,
            "modelo": e.target.querySelector("select[name=carmodel]").value,
            "provincia": e.target.querySelector("select[name=place]").value,
            "concesionario": _this.stands[e.target.querySelector('select[name=place]').value].id,
            "exposicion": _this.stands[e.target.querySelector('select[name=place]').value].showroom,
            "utm_campaign": _this.traffic.campaign,
            "utm_medium": _this.traffic.medium,
            "utm_source": _this.traffic.source,
        }]);

        console.log(json);

        this.request.onreadystatechange = (e) => {
            if (e.target.readyState == XMLHttpRequest.DONE && e.target.status == 200) {
                button.classList.remove('loading');
                window.location.href = 'obrigado';
                _this.mailchimpForm(values);
            } else if (e.target.readyState == XMLHttpRequest.DONE && e.target.status != 200) {
                _this.alert.firstChild.data = _this.alert.getAttribute('data-error');
                _this.openAlert();
            }
        }

        this.request.open('POST', `${window.location.origin}/.netlify/functions/form`);
        this.request.setRequestHeader('Content-type', 'application/json');
        this.request.send(json);
    },

    validateRecaptcha() {
        return grecaptcha.getResponse().length > 0;
    },

    updateStand(el) {
        const _this = this;
        el.querySelector("input[name=stand]").value = _this.stands[el.querySelector('select[name=place]').value].name;
    },

    stands: {
        'Fundão': {
            name: 'A MatosCar',
            id: '0010N000059pTdW',
            showroom: 'a170N00000bT2mu'
        },
        'Évora': {
            name: 'A MatosCar',
            id: '0010N000059pTdW',
            showroom: 'a170N00000bT2mt'
        },
        'Penafiel': { 
            name: 'AMF',
            id: '0010N000059pRqo',
            showroom: 'a170N00000ZOgSD'
        },
        'Setúbal': {
            name: 'Auto Avenida',
            id: '0010N000059pRqt',
            showroom: 'a170N00000ZOgSK'
        },
        'Castelo Branco': {
            name: 'Auto Mecânica Alcambar',
            id: '0010N000059pTdW',
            showroom: 'a170N00000bTERk'
        },
        'Figueira da Foz': {
            name: 'Caldeira & Caldeira',
            id: '0010N000059pRsu',
            showroom: 'a170N00000bTERf'
        },
        'Beja': {
            name: 'Cameirinha',
            id: '0010N000059pRtd',
            showroom: 'a170N00000ZOgUm'
        },
        'Braga': {
            name: 'Cardan',
            id: '0010N000059pTfr',
            showroom: 'a170N00000ZOgsJ'
        },
        'Guimarães': {
            name: 'Cardan',
            id: '0010N000059pTfm',
            showroom: 'a170N00000bT2n3'
        },
        'Aveiro': {
            name: 'Corvauto',
            id: '0010N000059pRrh',
            showroom: 'a170N00000ZOgSu'
        },
        'Sines': {
            name: 'Diacar',
            id: '0010N000059pRrr',
            showroom: 'a170N00000ZOgSz'
        },
        'Guarda': {
            name: 'Elpídio & Horácio',
            id: '0010N000059pRrw',
            showroom: 'a170N00000ZOgT4'
        },
        'Leiria': {
            name: 'F H  Rocha Marques',
            id: '0010N000059pRs6',
            showroom: 'a170N00000bT2n8'
        },
        'Vila Real': {
            name: 'Irmãos Leite',
            id: '0010N000059pTfw',
            showroom: 'a170N00000ZOgTL'
        },
        'Porto': {
            name: 'JOP',
            id: '0010N000059pTg1',
            showroom: 'a170N00000ZOgsZ'
        },
        'Golegã': {
            name: 'Julião Luz e Filhos',
            id: '0010N000059pRsQ',
            showroom: 'a170N00000ZOgTR'
        },
        'Barcelos': {
            name: 'Teixeira e Martins-Automóveis',
            id: '0010N000059pRuq',
            showroom: 'a170N00000ZOgVv'
        },
        'Viana do Castelo': {
            name: 'Teixeira e Martins-Automóveis',
            id: '0010N000059pRuq',
            showroom: 'a170N00000bT2iN'
        },
        'Póvoa de Varzim': {
            name: 'KV Automóveis',
            id: '0010N000059pRuq',
            showroom: 'a170N00000bT2iN'
        },
        'Angra do Heroísmo': {
            name: 'Loureiro Almeida & Filhos',
            id: '0010N000059pRsa',
            showroom: 'a170N00000bT2nD'
        },
        'Caldas da Rainha': {
            name: 'LPM',
            id: '0010N000059pRsf',
            showroom: 'a170N00000ZOgTl'
        },
        'Coimbra': {
            name: 'M Coutinho Centro',
            id: '0010N000059pRsu',
            showroom: 'a170N00000ZPorL'
        },
        'Funchal': {
            name: 'Madeira Auto-Car',
            id: '0010N000059pRsk',
            showroom: 'a170N00000bT2nI'
        },
        'Ponta Delgada': {
            name: 'Moniz de Sá',
            id: '0010N000059pRt9',
            showroom: 'a170N00000bT2iX'
        },
        'Faro': {
            name: 'MSCAR',
            id: '0010N000059pRtJ',
            showroom: 'a170N00000ZOgUX'
        },
        'Portimão': {
            name: 'MSCAR',
            id: '0010N000059pTgG',
            showroom: 'a170N00000bT2iS'
        },
        'Portalegre': {
            name: 'MSCMultiribeiroAR',
            id: '0010N000059pRtO',
            showroom: 'a170N00000ZOgUc'
        },
        'Alfragide': {
            name: 'Santogal',
            id: '0010N000059pTfI',
            showroom: 'a170N00000ZOgrs'
        },
        'Loures': {
            name: 'Santogal',
            id: '0010N000059pRq0',
            showroom: 'a170N00000ZOgRt'
        },
        'Sintra': {
            name: 'Santogal',
            id: '0010N000059pTfD',
            showroom: 'a170N00000ZOgri'
        },
        'Almada': {
            name: 'SGS Car',
            id: '0010N000059pRu2',
            showroom: 'a170N00000ZOgVA'
        },
        'Montijo': {
            name: 'SGS Car',
            id: '0010N000059pTgQ',
            showroom: 'a170N00000bT2id'
        },
        'Viseu': {
            name: 'Soveco',
            id: '0010N000059pTgV',
            showroom: 'a170N00000ZOgt3'
        },
        'Cascais': {
            name: 'Univex',
            id: '0010N000059pQvS',
            showroom: 'a170N00000ZOgOS'
        },
        'Lisboa': {
            name: 'Univex',
            id: '0010N000059pQw6',
            showroom: 'a170N00000ZOgOd'
        }
    }
};
